/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import { Button, Card, Dialog, Grid } from "@mui/material";
import { useCallback, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { IErrorList, IErrorProps } from "../../models";
import classes from "./ErrorDialogForServerError.module.css";
import { RootState } from "../../store";
import { tenantActions } from "../../store/Tenant/tenant-slice";
import { PrimaryBtn } from "../../utils/buttons/Buttons";
import LogoutUser from "../../utils/methods/logout/LogoutUser";
interface IDialogForErrorProps {
  open: boolean;
  onClose(): void;
  errorList: Array<IErrorProps>;
  errorType: "serverError" | "noURLFoundError" | "noAccessError";
}

const DialogForError = (props: IDialogForErrorProps) => {
  const [logoutUser, setLogoutUser] = useState(false);
  let errorBody = "This could be because:";
  let image1 = "";
  let messageHints: string[] = [];
  let header: string = "";
  const { open, onClose, errorList, errorType } = props;

  if (errorType === "noURLFoundError") {
    image1 = require("../../images/imagePageNotFound.png");
    header = "NO URL FOUND";
  } else if (errorType === "serverError") {
    image1 = require("../../images/imageServerError.png");
    header = "NO DATA AVAILABLE";
  } else if (errorType === "noAccessError") {
    image1 = require("../../images/imageNoAccess.png");
    header = "FORBIDDEN : YOU NEED PERMISSIONS";
    errorBody = "";
  } else {
  }

  errorList?.forEach((element: IErrorProps, index) => {
    const { errorCode, errorMessage } = element;

    if (errorType === "noURLFoundError" && errorCode === undefined) {
      messageHints = [
        "The page you're looking for appears to have been moved,deleted or doesn't exist.",
      ];
    } else if (
      errorType === "serverError" &&
      errorCode !== null &&
      errorCode !== 400 &&
      errorCode !== undefined
    ) {
      if (
        messageHints?.find(
          (x) => x === "" || x.toLowerCase() === errorMessage.toLowerCase()
        )
      ) {
      } else {
        const newErrorMessages = [...messageHints, errorMessage];
        messageHints = newErrorMessages;
      }
    } else if (errorType === "noAccessError") {
      const newErrorMessages = [...messageHints, errorMessage];
      messageHints = newErrorMessages;
    } else {
    }
  });

  /**
   * To show the logout button on the popup incase the loggedin user
   * doesn't have access to UDP Admin portal
   * on Logout button click, user will be signed out and redirects to Sign in page
   */
  let logoutBtnJsx = null;
  if (errorType === "noAccessError") {
    logoutBtnJsx = (
      <Grid container justifyContent="flex-end" sx={{ padding: "24px" }}>
        <PrimaryBtn btnText="Logout" onClick={() => setLogoutUser(true)} />
      </Grid>
    );
  }

  const DialogForError = (
    <Dialog open={open} onClose={onClose} style={{ alignSelf: "center" }}>
      <Card
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          backgroundColor: "#404040",
          border: "1px solid #404040",
          borderRight: "10px",
          width: 500,
        }}
      >
        <div
          style={{
            width: "30%",
            margin: "5%",
            marginLeft: "5%",
            height: "70%",
          }}
        >
          <img
            src={image1}
            alt="Image1"
            style={{ paddingTop: 15, height: 120, width: 120 }}
          />
        </div>
        <div style={{ width: "70%", height: "100%", marginTop: "5%" }}>
          <p className={classes.hearderStyle}>{header}</p>
          <p className={classes.contentStyle}>{errorBody}</p>
          <ul style={{ paddingLeft: 10, marginTop: -10 }}>
            {messageHints.map((messageHint) => (
              <li className={classes.contentStyle}>{messageHint}</li>
            ))}
          </ul>
          <Grid container justifyContent="flex-end">
            {errorType != "noAccessError" && (
              <Button className={classes.okButton} onClick={props.onClose}>
                Okay
              </Button>
            )}
          </Grid>
          {logoutBtnJsx}
          {logoutUser && <LogoutUser />}
        </div>
      </Card>
    </Dialog>
  );

  return <>{open && DialogForError}</>;
};
export default DialogForError;
